var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "card",
    {
      staticClass: "b-0 compare-sheet p-6",
      attrs: { borderSize: 0, background: "warning-05" }
    },
    [
      _c("article", [
        _c(
          "div",
          { staticClass: "flex-row mb-4 flex-bottom" },
          [
            _c("SaasIcon", {
              attrs: { width: "35", height: "24", icon: "sellsyCloud" }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "capitalize fs-5 ml-2" }, [
              _vm._v(
                "Sellsy " +
                  _vm._s(_vm.$filters.lowerCase(_vm.previousCurrentPlanLabel))
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex-item-right fs-3" }, [
              _c("span", { staticClass: "bold" }, [
                _vm._v(_vm._s(_vm.labelPlan))
              ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "ov-auto mb-0 cart-recap-products" },
          [
            _vm._l(_vm.previousProductsWithLicences, function(product) {
              return _c(
                "li",
                {
                  key: product.code,
                  staticClass: "mb-2 flex-row",
                  class: {
                    "mb-to-free-licences":
                      _vm.freeLicencesByProduct(product.id) &&
                      !_vm.previousFreeLicencesByProduct(product.id)
                  }
                },
                [
                  _c("div", [
                    _c("p", { staticClass: "gray-80 mb-1 mt-0 fs-3" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$l10n.n__(
                              "%(total)s licence %(productsName)s",
                              "%(total)s licences %(productsName)s",
                              _vm.previousProducts[product.id].quantity,
                              {
                                total:
                                  _vm.previousProducts[product.id].quantity,
                                productsName: product.title
                              }
                            )
                          ) +
                          "\n                    "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.previousFreeLicencesByProduct(product.id)
                      ? _c("span", { staticClass: "gray-80" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$l10n.n__(
                                  "Dont %s offerte",
                                  "Dont %s offertes",
                                  _vm.previousFreeLicencesByProduct(product.id),
                                  _vm.previousFreeLicencesByProduct(product.id)
                                )
                              ) +
                              "\n                    "
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm.previousProducts[product.id].total
                    ? [
                        _vm.previousFreeLicencesByProduct(product.id)
                          ? _c("p", { staticClass: "flex-item-right my-0" }, [
                              _c("span", { staticClass: "strike gray-80" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.$filters.numberFormatToFloatWithOptions(
                                        _vm.previousProducts[product.id].total
                                          .monthly.total_amount,
                                        _vm.numformat,
                                        true
                                      )
                                    ) +
                                    "\n                        "
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "success-50 fs-3 pl-2 semibold"
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$filters.numberFormatToFloatWithOptions(
                                          _vm.previousProducts[product.id].total
                                            .monthly.total_amount_discounted,
                                          _vm.numformat,
                                          true
                                        )
                                      ) +
                                      "\n                            " +
                                      _vm._s(_vm.$l10n.__("/mois")) +
                                      "\n                        "
                                  )
                                ]
                              )
                            ])
                          : _c(
                              "p",
                              {
                                staticClass:
                                  "flex-item-right my-0 fs-3 semibold gray-80"
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$filters.numberFormatToFloatWithOptions(
                                        _vm.previousProducts[product.id].total
                                          .monthly.total_amount_discounted,
                                        _vm.numformat,
                                        true
                                      )
                                    ) +
                                    "\n                        " +
                                    _vm._s(_vm.$l10n.__("/mois")) +
                                    "\n                    "
                                )
                              ]
                            )
                      ]
                    : _vm._e()
                ],
                2
              )
            }),
            _vm._v(" "),
            _vm._l(_vm.previousPacksWithLicences, function(product) {
              return _c(
                "li",
                { key: product.code, staticClass: "mb-2 flex-row" },
                [
                  _c("div", [
                    _c("p", { staticClass: "gray-80 mb-1 mt-0 fs-3" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$l10n.__("Module %(productsName)s", {
                              productsName: product.title
                            })
                          ) +
                          "\n                    "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.previousProducts[product.id].total
                    ? [
                        _vm.previousProducts[product.id].total.monthly
                          .total_amount_discounted <
                        _vm.previousProducts[product.id].total.monthly
                          .total_amount
                          ? _c(
                              "p",
                              { staticClass: "flex-item-right my-0 semibold" },
                              [
                                _c("span", { staticClass: "strike gray-80" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$filters.numberFormatToFloatWithOptions(
                                          _vm.previousProducts[product.id].total
                                            .monthly.total_amount,
                                          _vm.numformat,
                                          true
                                        )
                                      ) +
                                      "\n                        "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "success-50 fs-3 pl-2" },
                                  [
                                    _vm.previousProducts[product.id].total
                                      .monthly.total_amount_discounted !== 0
                                      ? [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.$filters.numberFormatToFloatWithOptions(
                                                  _vm.previousProducts[
                                                    product.id
                                                  ].total.monthly
                                                    .total_amount_discounted,
                                                  _vm.numformat,
                                                  true
                                                )
                                              ) +
                                              "\n                                " +
                                              _vm._s(_vm.$l10n.__("/mois")) +
                                              "\n                            "
                                          )
                                        ]
                                      : [_vm._v(_vm._s(_vm.$l10n.__("Offert")))]
                                  ],
                                  2
                                )
                              ]
                            )
                          : _c(
                              "p",
                              {
                                staticClass:
                                  "flex-item-right my-0 fs-3 semibold gray-80"
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$filters.numberFormatToFloatWithOptions(
                                        _vm.previousProducts[product.id].total
                                          .monthly.total_amount_discounted,
                                        _vm.numformat,
                                        true
                                      )
                                    ) +
                                    "\n                        " +
                                    _vm._s(_vm.$l10n.__("/mois")) +
                                    "\n                    "
                                )
                              ]
                            )
                      ]
                    : _vm._e()
                ],
                2
              )
            })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "separator my-3 block" }),
      _vm._v(" "),
      _c("article", { staticClass: "flex-row jc-space" }, [
        _c("div", { staticClass: "flex-column fs-3 cart-recap-total-label" }, [
          _c("span", { staticClass: "mb-1" }, [
            _vm._v(_vm._s(_vm.$l10n.__("Total HT avant remise")))
          ]),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "mb-3 bold fs-2 flex-row ai-center" },
            [
              _vm._v(_vm._s(_vm.$l10n.__("Variation")) + "\n                "),
              _c("SaasIcon", {
                staticClass: "ml-1",
                attrs: {
                  width: "6",
                  height: "12",
                  icon: _vm.getArrowOrientation(
                    _vm.variousTotalYearly.total_amount
                  )
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("span", { staticClass: "mb-1" }, [
            _vm._v(_vm._s(_vm.$l10n.__("Remise")))
          ]),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "mb-3 bold fs-2 flex-row ai-center" },
            [
              _vm._v(_vm._s(_vm.$l10n.__("Variation")) + "\n                "),
              _c("SaasIcon", {
                staticClass: "ml-1",
                attrs: {
                  width: "6",
                  height: "12",
                  icon: _vm.getArrowOrientation(
                    _vm.variousTotalYearly.total_amount_discount
                  )
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("span", { staticClass: "mb-1" }, [
            _vm._v(_vm._s(_vm.$l10n.__("Total HT")))
          ]),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "mb-3 bold fs-2 flex-row ai-center" },
            [
              _vm._v(_vm._s(_vm.$l10n.__("Variation")) + "\n                "),
              _c("SaasIcon", {
                staticClass: "ml-1",
                attrs: {
                  width: "6",
                  height: "12",
                  icon: _vm.getArrowOrientation(
                    _vm.variousTotalYearly.total_amount_discounted
                  )
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.previousTaxRate && _vm.previousTaxRate !== 0
            ? _c("span", { staticClass: "mb-3" }, [
                _vm._v(
                  _vm._s(_vm.$l10n.__("TVA")) +
                    " " +
                    _vm._s(_vm.previousTaxRate) +
                    "%"
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex-column aright fs-3" }, [
          _c("span", { staticClass: "mb-1" }, [
            _vm._v(
              _vm._s(
                _vm.$filters.numberFormatToFloatWithOptions(
                  _vm.previousTotalYearly.total_amount,
                  _vm.numformat,
                  true
                )
              ) +
                "\n                " +
                _vm._s(_vm.$l10n.__("/an"))
            )
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "mb-3 bold fs-2" }, [
            _vm._v(
              _vm._s(
                _vm.$filters.numberFormatToFloatWithOptions(
                  _vm.variousTotalYearly.total_amount,
                  _vm.numformat,
                  true
                )
              ) +
                "\n                " +
                _vm._s(_vm.$l10n.__("/an"))
            )
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "mb-1" }, [
            _vm._v(
              _vm._s(
                _vm.$filters.numberFormatToFloatWithOptions(
                  _vm.previousTotalYearly.total_amount_discount,
                  _vm.numformat,
                  true
                )
              ) +
                "\n                " +
                _vm._s(_vm.$l10n.__("/an"))
            )
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "mb-3 bold fs-2" }, [
            _vm._v(
              _vm._s(
                _vm.$filters.numberFormatToFloatWithOptions(
                  _vm.variousTotalYearly.total_amount_discount,
                  _vm.numformat,
                  true
                )
              ) +
                "\n                " +
                _vm._s(_vm.$l10n.__("/an"))
            )
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "mb-1" }, [
            _vm._v(
              _vm._s(
                _vm.$filters.numberFormatToFloatWithOptions(
                  _vm.previousTotalYearly.total_amount_discounted,
                  _vm.numformat,
                  true
                )
              ) +
                "\n                " +
                _vm._s(_vm.$l10n.__("/an"))
            )
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "mb-3 bold fs-2" }, [
            _vm._v(
              _vm._s(
                _vm.$filters.numberFormatToFloatWithOptions(
                  _vm.variousTotalYearly.total_amount_discounted,
                  _vm.numformat,
                  true
                )
              ) +
                "\n                " +
                _vm._s(_vm.$l10n.__("/an"))
            )
          ]),
          _vm._v(" "),
          _vm.previousTaxRate && _vm.previousTaxRate !== 0
            ? _c("span", { staticClass: "mb-3" }, [
                _vm._v(
                  _vm._s(
                    _vm.$filters.numberFormatToFloatWithOptions(
                      _vm.previousTotalYearly.total_amount_vat,
                      _vm.numformat,
                      true
                    )
                  ) + "\n            "
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex-column aright fs-3" }, [
          _c("span", { staticClass: "mb-1" }, [
            _vm._v(
              _vm._s(
                _vm.$filters.numberFormatToFloatWithOptions(
                  _vm.previousTotalMonthly.total_amount,
                  _vm.numformat,
                  true
                )
              ) +
                "\n                " +
                _vm._s(_vm.$l10n.__("/mois"))
            )
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "mb-3 bold fs-2" }, [
            _vm._v(
              _vm._s(
                _vm.$filters.numberFormatToFloatWithOptions(
                  _vm.variousTotalMonthly.total_amount,
                  _vm.numformat,
                  true
                )
              ) +
                "\n                " +
                _vm._s(_vm.$l10n.__("/mois"))
            )
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "mb-1" }, [
            _vm._v(
              "\n                " +
                _vm._s(
                  _vm.$filters.numberFormatToFloatWithOptions(
                    _vm.previousTotalMonthly.total_amount_discount,
                    _vm.numformat,
                    true
                  )
                ) +
                "\n                " +
                _vm._s(_vm.$l10n.__("/mois"))
            )
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "mb-3 bold fs-2" }, [
            _vm._v(
              "\n                " +
                _vm._s(
                  _vm.$filters.numberFormatToFloatWithOptions(
                    _vm.variousTotalMonthly.total_amount_discount,
                    _vm.numformat,
                    true
                  )
                ) +
                "\n                " +
                _vm._s(_vm.$l10n.__("/mois"))
            )
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "mb-1" }, [
            _vm._v(
              "\n                " +
                _vm._s(
                  _vm.$filters.numberFormatToFloatWithOptions(
                    _vm.previousTotalMonthly.total_amount_discounted,
                    _vm.numformat,
                    true
                  )
                ) +
                "\n                " +
                _vm._s(_vm.$l10n.__("/mois"))
            )
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "mb-3 bold fs-2" }, [
            _vm._v(
              "\n                " +
                _vm._s(
                  _vm.$filters.numberFormatToFloatWithOptions(
                    _vm.variousTotalMonthly.total_amount_discounted,
                    _vm.numformat,
                    true
                  )
                ) +
                "\n                " +
                _vm._s(_vm.$l10n.__("/mois"))
            )
          ]),
          _vm._v(" "),
          _vm.previousTaxRate && _vm.previousTaxRate !== 0
            ? _c("span", { staticClass: "mb-3" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$filters.numberFormatToFloatWithOptions(
                        _vm.previousTotalMonthly.total_amount_vat,
                        _vm.numformat,
                        true
                      )
                    ) +
                    "\n            "
                )
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "separator my-3" }),
      _vm._v(" "),
      _c("article", { staticClass: "flex-row jc-space" }, [
        _c("div", { staticClass: "cart-recap-total-label" }, [
          _c("p", { staticClass: "fs-4 my-0 bold cart-recap-total-label" }, [
            _vm._v(_vm._s(_vm.$l10n.__("Total TTC")))
          ]),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "mb-3 fs-2 flex-row ai-center" },
            [
              _vm._v(_vm._s(_vm.$l10n.__("Variation")) + "\n                "),
              _c("SaasIcon", {
                staticClass: "ml-1",
                attrs: {
                  width: "6",
                  height: "12",
                  icon: _vm.getArrowOrientation(
                    _vm.variousTotalYearly.total_amount_tax_included
                  )
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex-column aright fs-3" }, [
          _c("p", { staticClass: "fs-4 my-0 aright bold" }, [
            _vm._v(
              "\n                " +
                _vm._s(
                  _vm.$filters.numberFormatToFloatWithOptions(
                    _vm.previousTotalYearly.total_amount_tax_included,
                    _vm.numformat,
                    true
                  )
                ) +
                "\n                "
            ),
            _c("span", { staticClass: "fs-2" }, [
              _vm._v(_vm._s(_vm.$l10n.__("/an")))
            ])
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "mb-3 fs-2" }, [
            _vm._v(
              "\n                " +
                _vm._s(
                  _vm.$filters.numberFormatToFloatWithOptions(
                    _vm.variousTotalYearly.total_amount_tax_included,
                    _vm.numformat,
                    true
                  )
                ) +
                "\n                " +
                _vm._s(_vm.$l10n.__("/an"))
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex-column aright fs-3" }, [
          _c("p", { staticClass: "fs-4 my-0 aright bold" }, [
            _vm._v(
              "\n                " +
                _vm._s(
                  _vm.$filters.numberFormatToFloatWithOptions(
                    _vm.previousTotalMonthly.total_amount_tax_included,
                    _vm.numformat,
                    true
                  )
                ) +
                "\n                "
            ),
            _c("span", { staticClass: "fs-2" }, [
              _vm._v(_vm._s(_vm.$l10n.__("/mois")) + " ")
            ])
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "mb-3 fs-2" }, [
            _vm._v(
              "\n                " +
                _vm._s(
                  _vm.$filters.numberFormatToFloatWithOptions(
                    _vm.variousTotalMonthly.total_amount_tax_included,
                    _vm.numformat,
                    true
                  )
                ) +
                "\n                " +
                _vm._s(_vm.$l10n.__("/mois")) +
                "\n            "
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }